import { IconButton } from "@mui/material"
import { AuthoringAmendsContentDialog } from "authoring/routes/project/amends/components/authoring-amends-content-dialog"
import { normalizeAudienceAmends } from "authoring/routes/project/amends/lib/audience-aware-amends.mjs"
import { useDialog } from "lib/@hooks/useDialog"
import Iconify from "minimals-template/components/Iconify"
import { LEADING_SUMMARY_AMENDS_KEY } from "authoring/routes/project/amends/lib/constants/amends-keys"

export function LeadingSummaryAuthorNoteBoxAction({ amend }) {
    const openLeadingSummaryDialog = useDialog(<AuthoringAmendsContentDialog />, { maxWidth: "md", fullWidth: true })

    if (!isLeadingSummary(amend)) return null

    return (
        <IconButton
            aria-label="View leading summary"
            size="small"
            color="primary"
            sx={{ p: 0.25, mt: 0.25 }}
            onClick={showLeadingSummary}
            data-cy="leading-summary-view-details"
        >
            <Iconify icon="mdi:eye" width={18} />
        </IconButton>
    )

    async function showLeadingSummary() {
        await openLeadingSummaryDialog({
            noteData: normalizeAudienceAmends(amend?.payload ?? {}),
            title: "Leading Summary",
        })
    }
}

function isLeadingSummary(amend) {
    const amendsKey = amend?.payload?.amendsKey ?? amend?.payload?.field
    return amendsKey === LEADING_SUMMARY_AMENDS_KEY
}
